import { render, staticRenderFns } from "./team-registration.vue?vue&type=template&id=3a6811a9&scoped=true&"
import script from "./team-registration.vue?vue&type=script&lang=js&"
export * from "./team-registration.vue?vue&type=script&lang=js&"
import style0 from "./team-registration.vue?vue&type=style&index=0&id=3a6811a9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a6811a9",
  null
  
)

export default component.exports